module.exports = __webpack_public_path__ + "img/智驹app下载地址.d4c42f45.jpg";